import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root',
})

export class MaterialService {

  constructor(
    private apiCommonService: ApiCommonService) {
  }

  getGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Materials', event, searchQuery, '', filterQuery);
  }

  getMaterials(): Observable<object> {
    return this.apiCommonService.get(`Materials/LookUp`);
  }

  getUnits(): Observable<any> {
    return this.apiCommonService.get(`Admin/Units/LookUp`);
  }

  getCategories(): Observable<any> {
    return this.apiCommonService.get(`Materials/CategoryLookUp`);
  }

  create(data: object): Observable<object> {
    return this.apiCommonService.post('Materials', data);
  }

  edit(MaterialId: string): Observable<object> {
    return this.apiCommonService.get(`Materials/Edit?MaterialId=${MaterialId}`);
  }

  update(data: object): Observable<object> {
    return this.apiCommonService.post('Materials/Update', data);
  }

  updateMaterials(data: any): Observable<any> {
    return this.apiCommonService.post('Materials/Updates', data);
  }

  exportMaterials(event: any, searchQuery: string, filterQuery: string): Observable<object> {
    return this.apiCommonService.export('Materials/export', event, searchQuery, filterQuery, '');
  }

  getMaterialDimension(materialId: number): Observable<any> {
    return this.apiCommonService.get(`Materials/Dimension?MaterialId=${materialId}`);
  }

  materialStatusUpdate(data: object): Observable<object> {
    return this.apiCommonService.put('Materials/Delete', data);
  }

  deleteImage(data: any): Observable<any> {
    return this.apiCommonService.put(`Materials/Image/Delete`, data);
  }
}
